import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=b908c7fa&scoped=true"
import script from "./CardSkeleton.vue?vue&type=script&lang=js"
export * from "./CardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=b908c7fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b908c7fa",
  null
  
)

export default component.exports